import { ThunkApiType } from 'types/utils';
import authFetch, { checkForUnauthorizedResponse } from 'utils/axios';

export const getSettlementLettersThunk = async (
	_: any,
	thunkAPI: ThunkApiType,
) => {
	const URL = `/carrier-docs`;

	const {
		inputSettlementLettersCarriers,
		inputSettlementLettersStartDate,
		inputSettlementLettersEndDate,
	} = thunkAPI.getState().form;

	const carriersFilter = !inputSettlementLettersCarriers.includes('All')
		? inputSettlementLettersCarriers
				.map((carrier: string) => `carrierCodes=${carrier}`)
				.join('&')
		: '';

	const isFirstFilter = !!carriersFilter ? '&' : '';

	const startDateFilter = !!inputSettlementLettersStartDate
		? `${isFirstFilter}periodStart=${inputSettlementLettersStartDate}`
		: '';

	const endDateFilter = !!inputSettlementLettersEndDate
		? `&periodEnd=${inputSettlementLettersEndDate}`
		: '';

	const filtersApplied = carriersFilter || startDateFilter || endDateFilter;
	const hasFilters = filtersApplied ? '?' : '';

	const getDocumentsURL = `${URL}${hasFilters}${carriersFilter}${startDateFilter}${endDateFilter}`;

	try {
		const response = await authFetch.get(getDocumentsURL);
		return response.data || [];
	} catch (error: ThunkApiType) {
		return checkForUnauthorizedResponse(error, thunkAPI);
	}
};

export const getSettlementLetterThunk = async (
	{ uuid }: { uuid: string },
	thunkAPI: ThunkApiType,
) => {
	const getDocumentsURL = `/carrier-docs/${uuid}/content`;

	try {
		const response = await authFetch.get(getDocumentsURL, {
			responseType: 'blob',
		});
		return URL.createObjectURL(response.data);
	} catch (error: ThunkApiType) {
		return checkForUnauthorizedResponse(error, thunkAPI);
	}
};
